<app-wizard
  [prevButtonEnabled]="true"
  [nextButtonEnabled]="true"
  [prevButtonText]="prevButtonText()"
  [nextButtonText]="nextButtonText()"
  [prevButtonHasChevron]="prevButtonHasChevron()"
  [nextButtonHasChevron]="nextButtonHasChevron()"
  [items]="items()"
  (stepSelection)="onStepSelection($event)"
  (nextButtonClicked)="onNextButtonClick()"
  (prevButtonClicked)="onPreviousButtonClick()"
>
  <app-wizard-step
    stepId="form-wizard-progress-tab1"
    [stepNumber]="1"
    [isActive]="stepIndex() == 1"
    ><div class="card">
      <div class="card-header">
        {{ "registrationWizard.legalPersonForm.dataOfLegalPerson" | translate }}
      </div>
      <div class="card-body">
        <app-legal-person-validated-form
          [formGroupInput]="legalPersonForm"
          [taxNumberDisabled]="false"
          [showFillDataButton]="true"
        />
      </div>
    </div>
  </app-wizard-step>
  <app-wizard-step
    stepId="form-wizard-progress-tab2"
    [stepNumber]="2"
    [isActive]="stepIndex() == 2"
  >
    <app-document-upload-form [formGroupInput]="documentUpload" />
  </app-wizard-step>
  <app-wizard-step
    stepId="form-wizard-progress-tab3"
    [stepNumber]="3"
    [isActive]="stepIndex() == 3"
  >
    <app-proof-of-professional-status-form
      [formGroupInput]="proofOfProfessionalStatus"
    />
  </app-wizard-step>
</app-wizard>
